import { render, staticRenderFns } from "./tandem.vue?vue&type=template&id=c8b26ab2&scoped=true&"
import script from "./tandem.vue?vue&type=script&lang=js&"
export * from "./tandem.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaDetails.less?vue&type=style&index=0&id=c8b26ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b26ab2",
  null
  
)

component.options.__file = "tandem.vue"
export default component.exports